import deepEqual from 'deep-equal'

export default {
  methods: {
    isDeepEqual(source, target) {
      return deepEqual(source, target, { strict: false })
    }
  }
}
